import App from '@/App.vue'
export default {
  path: '/news',
  component: App,
  children: [
    {
      path: '',
      name: 'NewsIndex',
      component: () => import('@/views/news/Index.vue'),
      meta: {
        title: '新闻中心'
      },
    },
    {
      path: 'detail',
      name: 'NewsDetail',
      component: () => import('@/views/news/details/Index.vue'),
      meta: {
        title: '新闻详情'
      }
    }
  ]
}

